import { Component } from "react";
import { H_01_HORA } from "../funcs/constants";


class VertteStorage extends Component {

    get(name) {
        const storage = localStorage.getItem(name);
        if (storage === 'undefined') {
            return undefined
        }
        return storage;
    }

    set(name, value) {
        localStorage.setItem(name, value);
    }

    setWithExpiry(key, value, ttl) {
        if (!ttl) {
            ttl = H_01_HORA;
        }
        const now = new Date();
        const item = {
            value,
            expiry: now.getTime() + ttl,
        }
        localStorage.setItem(key, JSON.stringify(item));
    }

    getWithExpiry(key) {
        const itemStr = this.get(key);
        if (!itemStr || itemStr === 'null') {
            return undefined;
        }

        const item = JSON.parse(itemStr);
        const now = new Date();
        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key);
            return undefined;
        }
        return item.value;
    }

    clear(name) {
        localStorage.clear(name)
    }

    clearAll() {
        localStorage.clear();
    }
}

const vertteStorage = new VertteStorage();
export default vertteStorage;